var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded-sm px-2 py-0.5 text-xs tracking-wide uppercase bg-neutral-300 text-neutral-700"},[_vm._v("nil")])}
var staticRenderFns = []

export { render, staticRenderFns }